import EventEmitter from 'eventemitter3';

export default class ProjectHeaderManager extends EventEmitter {

    _styleConsole = 'background: #222; color: #ff8c8c';
    _classes = {
        projectContainer: 'js-date-project-container',
        projectItem: 'js-project-item',
        projectHeader: 'js-project-header',
        header: 'js-header',
        initLoad: 'anim-init-load'
    };
    _project = {
        old : 0,
        current : 0,
        next : 0
    }

    constructor() {
        super();

        this._retrieveDOM();
        this.bind();
    }

    _retrieveDOM() {

        this._views = {};

        // Projects
        this._views.project = {
            container : document.body.querySelector( '.' + this._classes.projectContainer ),
            items : null,
            headers : null
        }
        this._views.project.items = [].slice.call( this._views.project.container.querySelectorAll( '.' + this._classes.projectItem ) );
        this._views.project.headers = [].slice.call( this._views.project.container.querySelectorAll( '.' + this._classes.projectHeader ) );

        // Header => add header to project list
        this._views.header = document.body.querySelector( '.' + this._classes.header );
        this._views.project.headers.unshift( this._views.header );
    }

    _initDataDOM() {}

    bind() {}

    setIndex( index ) {
        this._project = index;
    }

    _initClass() {
        this._setProjectHeader();
    }

    initLoad() {
        this._views.project.container.classList.remove( this._classes.initLoad );
        this._views.header.classList.remove( this._classes.initLoad );
    }

    _setProjectHeader() {

        if( this._views.project.headers.length > 1 ) {
            if( this._project.current == 0 )
                this._views.project.headers[ 1 ].classList.add('first');
            else
                this._views.project.headers[ 1 ].classList.remove('first');
        }

        let header = this._views.project.headers[ this._project.current ];
        header.classList.add('show');

        // console.log(this._project.current)
        // console.log(header)
    }

    // resize() {}
    // update( top ) {}

    updateProjectHeader( direction ) {

        // console.log(this._project);
        // console.log(this._views.project.headers[ this._project.current ]);

        if( this._views.project.headers.length > 1 ) {
            if( this._project.current == 0 )
                this._views.project.headers[ 1 ].classList.add('first');
            else
                this._views.project.headers[ 1 ].classList.remove('first');
        }


        let newHeader = this._views.project.headers[ this._project.current ];
        if( newHeader.parentNode.classList.contains('open') == false )
            newHeader.classList.add('show');

        let oldHeader = this._views.project.headers[ this._project.old ];
        if( oldHeader.parentNode.classList.contains('open') == false )
            oldHeader.classList.remove('show');
    }
}


// WEBPACK FOOTER //
// ./src/js/pages/history/modules/project-header-manager.js